import { render } from "./WelcomeBoard.vue?vue&type=template&id=4018402d"
import script from "./WelcomeBoard.vue?vue&type=script&lang=js"
export * from "./WelcomeBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__